<template>
  <div id="areasComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout class="mb-2" row wrap>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="areaSearch"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search">
        </v-text-field>
          <v-dialog
            persistent
            v-model="dialog"
            max-width="500px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                v-on="on"
              >
              <v-icon left>group_work</v-icon>{{ $t('area.add') }}</v-btn>
            </template>
            <v-card>
              <v-toolbar
                class="primary--text"
                flat
              >
                <h2 class="font-weight-black primary--text mb-0">{{formTitle}}</h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-xs>
                  <v-form
                    lazy-validation
                    ref="form"
                    v-model="valid"
                  >
                    <v-text-field
                      required
                      :rules="rules.required"
                      :error-messages="errors.name"
                      :label="$t('general.name')"
                      v-model="editedItem.name"
                    >
                    </v-text-field>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary darken-1"
                  round
                  flat
                  @click="close"
                >
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                color="primary"
                round
                class="white--text"
                depressed
                :loading="loading"
                :disabled="loading"
                @click="save"
                >
                  {{ $t('general.save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-layout>
      <v-data-table
      :search="areaSearch"
      class="elevation-2"
      :headers="headers"
      :items="filterAreas"
      :loading="loadingItems"
      :rows-per-page-items="[10,15,25]"
      :pagination.sync="pagination"
      >
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                {{header.text}}</h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td class="text-sm-center">{{props.item.name}}</td>
            <td>
              <v-layout row justify-center>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                      outline
                      icon
                      color="info"
                      v-on="on"
                      @click="editItem(props.item)"
                      small
                      >
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('general.edit') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                    <v-btn
                    outline
                    icon
                    color="error"
                    v-on="on"
                    @click="removed(props.item)"
                    small
                    >
                      <v-icon small>delete</v-icon>
                    </v-btn>
                    </template>
                    <span>{{ $t('general.delete') }}</span>
                  </v-tooltip>
              </v-layout>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-dialog
        persistent
        v-model="removeDialog"
        max-width="500px"
      >
        <v-card>
          <v-toolbar
            flat>
            <h2 class="error--text font-weight-black mb-0">{{ $t('area.delete') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black"><span class="error--text">{{ $t('area.description')}}: </span>{{removedItem.name}}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="closeDelete">
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              color="error"
              round
              depressed
              :loading="loading"
              :disabled="loading"
              @click="deleteItem(removedItem)">
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'areasComponent',
  data () {
    return {
      areaSearch: '',
      pagination: {
        sortBy: 'name',
        descending: false,
        page: 1,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      },
      dialog: false,
      valid: true,
      loading: false,
      loadingItems: true,
      removeDialog: false,
      removedItem: {},
      editedIndex: -1,
      error: false,
      errorMessage: '',
      errors: {},
      areas: [],
      companies: [],
      userLogged: {
        roles: [
          {
            id: null
          }
        ],
        company: [
          {
            id: null
          }
        ]
      },
      editedItem: {
        name: '',
        company_id: null
      },
      defaultItem: {
        name: '',
        company_id: null
      }
    }
  },
  computed: {
    heading () {
      return this.$t('general.areas')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'far fa-clone fa-fw icon-color'
    },
    formTitle () {
      return this.editedIndex === -1 ? this.$t('area.add') : this.$t('area.edit')
    },
    headers () {
      return [
        {
          text: this.$t('general.name'),
          align: 'center',
          value: 'name',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    rules () {
      return this.$validationRules()
    },
    filterAreas () {
      if (this.userLogged.roles[0].id === 1) {
        return this.areas
      } else if (this.userLogged.roles[0].id === 2) {
        return this.areas.filter(item => item.company_id === this.userLogged.company[0].id)
      }
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    '$store.state.userLogged' () {
      this.getLogged()
    }
  },
  created () {
    this.getLogged()
    this.get()
  },
  methods: {
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    removed (item) {
      this.removedItem = item
      this.removeDialog = true
    },
    deleteItem (item) {
      this.loading = true
      const index = this.areas.indexOf(item)
      this.delete(item, index)
    },
    closeDelete () {
      this.removeDialog = false
      this.loading = false
    },
    close () {
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.loading = false
      this.$refs.form.resetValidation()
      this.errors = {}
    },
    editItem (item) {
      this.editedIndex = this.areas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    save () {
      this.errors = {}
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.editedIndex > -1) {
          this.put()
        } else {
          this.post()
        }
      }
    },
    get () {
      this.$emit('get', {
        context: this
      })
    },
    post () {
      if (this.userLogged.roles[0].id === 1) {
        this.$emit('post', {
          name: this.editedItem.name,
          company_id: this.editedItem.company_id,
          context: this
        })
      } else if (this.userLogged.roles[0].id === 2) {
        this.editedItem.company_id = this.userLogged.company[0].id
        this.$emit('post', {
          name: this.editedItem.name,
          company_id: this.editedItem.company_id,
          context: this
        })
      }
    },
    put () {
      this.$emit('put', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this
      })
    },
    delete (item, index) {
      this.$emit('delete', {
        item: item,
        index: index,
        context: this
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/areas.component.vue